<template>
  <pull-refresh
    style="min-height: 100vh"
    v-model="isLoading"
    @refresh="onRefresh"
  >
    <div>
      <div class="top">
        <div class="img">
          <img :src="userInfo.img" />
        </div>
        <div>
          <div class="nickname">昵称：{{ userInfo.nickname }}</div>
        </div>
      </div>
      <div class="list">
        <div class="item">
          <div class="left">停车场：</div>
          <div class="right">{{ detail.lot_name }}</div>
        </div>
        <div class="item">
          <div class="left">设备：</div>
          <div class="right">{{ detail.device_name }}</div>
        </div>
      </div>
      <div class="list">
        <div class="item">
          <div class="left">车牌号：</div>
          <div class="right">{{ detail.car_no }}</div>
        </div>
        <div class="item">
          <div class="left">入场时间：</div>
          <div class="right">{{ detail.starttime }}</div>
        </div>
      </div>
    </div>
    <van-dialog v-model="show" title=" " @confirm="List">
      请确认以无牌车身份入场
    </van-dialog>
  </pull-refresh>
</template>

<script>
import { getEnterListjieshun, payment } from '../api/api';
import { Tag, Button, Toast, PullRefresh, Dialog } from 'vant';
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {
    // Tag,
    // Button,
    PullRefresh,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      detail: {},
      isLoading: false,
      show: true,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {},
  methods: {
    async List() {
      try {
        let value = {};
        this.userInfo.wx_zfb === 'zfb'
          ? (value = {
              ...value,
              user_id: this.userInfo.user_id,
              wx_zfb: this.userInfo.wx_zfb,
            })
          : (value = {
              ...value,
              openid: this.userInfo.openid,
              wx_zfb: this.userInfo.wx_zfb,
            });
        const { data } = await getEnterListjieshun({ ...value });
        this.detail = data;
      } catch {}
    },
    onRefresh() {
      this.List();
      setTimeout(() => {
        Toast('刷新成功');
        this.isLoading = false;
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  height: 100%;
  background-color: #f1f1f1;
}
.unpayment {
  .title {
    margin-top: 1.85rem;
    padding: 1rem;
    text-align: left;
    background-color: #fff;
    margin-bottom: 0.1rem;
    .text {
      font-weight: 700;
    }
  }
  .order-list {
    background-color: #fff;
    padding: 0.5rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;
    .card-plate {
      text-align: left;
      font-size: 1rem;
      padding-bottom: 10rpx;
    }

    .card-title {
      font-size: 0.8rem;
      color: #8b8b8b;
      padding-left: 10rpx;
    }

    .card-price {
      font-size: 1rem;
      color: #858585;
      text-align: center;
    }
  }
  .car-list {
    background-color: #fff;
    padding: 0.5rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;
    .tag {
      margin-right: 0.5rem;
    }
    .del-button {
      height: 40px;
      width: 50px;
      padding: 0px 10px;
      font-size: 12px;
      margin-top: 5px;
      border-radius: 5px;
    }
  }
}
.top {
  margin-bottom: 0.5rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  .img {
    margin: 0.5rem;
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
  .nickname {
    font-size: 1rem;
    margin-bottom: 0.2rem;
    font-weight: 500;
  }
  .openId {
    font-size: 0.5rem;
    color: darkgoldenrod;
  }
}
.list {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  .item {
    background-color: #fff;
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 2.5rem;
    text-align: left;
    .left {
      width: 5rem;
      margin-left: 0.7rem;
    }
    .right {
      color: #8a8787;
    }
  }
}
.tips {
  font-size: 0.9rem;
  text-align: left;
  background-color: #fff;
  padding: 0.5rem;
  .title {
    line-height: 2.5rem;
    height: 2.5rem;
    border-bottom: 1px solid #f1f1f1;
  }
  .content {
    line-height: 2.5rem;
    height: 2.5rem;
    color: #8a8787;
  }
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 3rem;
  line-height: 3rem;
  background-color: #fff;
  width: 100%;
  .box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .left {
      text-align: left;
      width: 60%;
      margin-left: 0.5rem;
      .title {
        font-weight: 600;
        font-size: 1rem;
      }
      .price {
        color: red;
        font-weight: 600;
        font-size: 0.9rem;
      }
    }
    .right {
      width: 40%;
      background-color: #d0ad65;
      font-weight: 600;
      font-size: 1rem;
      color: #5d5128;
    }
  }
}
.van-dialog {
  line-height: 40px;
}
</style>
